import {HtmlDisplay} from "../../Components/Display";
import React from "react";

interface PackingListHeaderViewProps {
    shipAddress: string;
}

export const PackingListHeaderView = ({
                                    shipAddress
                                }: PackingListHeaderViewProps) => {

return <>
    <div className={`address`}>
        <div className={`address__from`}>
            FIMC-VI<br/>
            4716 W Montomery Ave<br/>
            Tampa, FL 33616
        </div>
        <HtmlDisplay html={shipAddress} className={`address__to`}/>
    </div>
</>;
};
